export const ADD = 'ORDER/ADD'
export const CANCEL = 'ORDER/CANCEL'
export const RESET = 'ORDER/RESET'
export const SET_SNAPSHOT = 'ORDER/SET_SNAPSHOT'
export const SET_SUBSCRIBED = 'ORDER/SET_SUBSCRIBED'
export const SET_REJECTED = 'ORDER/SET_REJECTED'
export const SET_UPDATE = 'ORDER/SET_UPDATE'
export const STOP = 'ORDER/STOP'
export const FETCH_MARGIN_CALL_DETAILS = 'ORDER/FETCH_MARGIN_CALL_DETAILS'
export const FETCH_MARGIN_ORDER_DETAILS = 'ORDER/FETCH_MARGIN_ORDER_DETAILS'
export const MESSAGE_RECEIVED = 'ORDER/MESSAGE_RECEIVED'
export const SET_MARGIN_DETAILS = 'ORDER/SET_MARGIN_DETAILS'
export const SET_ACTIVE_POSITION = 'ORDER/SET_ACTIVE_POSITION'
export const SET_MARGIN_CALL_DETAILS = 'ORDER/SET_MARGIN_CALL_DETAILS'
export const CLOSE_MARGIN_POSITION = 'ORDER/CLOSE_MARGIN_POSITION'
export const ADJUST_MARGIN_POSITION = 'ORDER/ADJUST_MARGIN_POSITION'
export const UPDATE_POSITION = 'ORDER/UPDATE_POSITION'
